
import * as noneRuntime$_3pC0Dyr2Qu_4oS1UqET1unh9QOnc9GHWYIFYUy5vC1k from '/builds/sbt/smsbat/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "png",
    "jpg",
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['none']: { provider: noneRuntime$_3pC0Dyr2Qu_4oS1UqET1unh9QOnc9GHWYIFYUy5vC1k, defaults: {} }
}
        